
    <div class="drawer-header border-bottom">
        <span class="title">Detalhes da Empresa Gestora</span>
        <p-button (onClick)="closeModal()" icon="pi pi-times" [rounded]="true" [text]="true" severity="secondary" />
    </div>
    <div class="content-drawer">
    
        <div class="basic-info">
            <div class="avatar">
                <p-avatar
                    *ngIf="!imageError && instituicao()?.foto; else defaultAvatar"
                    [image]="instituicao()?.foto"
                    shape="circle"
                    size="xlarge"
                    (onImageError)="imageError = true"
                />
                <ng-template #defaultAvatar>
                    <p-avatar
                        [label]="getInitials(instituicao()?.nome)"
                        [icon]="!instituicao()?.nome ? 'pi pi-building' : undefined"
                        shape="circle"
                        size="xlarge"
                    />
                </ng-template>
            </div>
            <div class="details">
                <h3 class="name">{{ instituicao()?.nome || 'Empresa Desconhecida' }}</h3>
                <div class="info align-items-center">
                    <span><strong>{{ instituicao()?.natureza | enumToString }}</strong></span>
                    <span>•</span>
                    <span>
                      <p-tag *ngIf="instituicao()?.activo" severity="success" value="Activa" />
                      <p-tag *ngIf="!instituicao()?.activo" severity="danger" value="Inactiva" />
                    </span>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-between gap-3 mt-4">
            <div class="card-info w-100">
                <div class="icon">
                    <i class="pi pi-phone"></i>
                </div>
                <div class="description">
                    <span class="title">Telefone</span>
                    <span class="info">{{ instituicao()?.telefone1 || 'Telefone desconhecido' }}</span>
                </div>
            </div>
            <div class="card-info w-100">
                <div class="icon">
                    <i class="pi pi-envelope"></i>
                </div>
                <div class="description">
                    <span class="title">Email</span>
                    <span class="info">{{ instituicao()?.email || 'Email desconhecido' }}</span>
                </div>
            </div>
        </div>
    
        <div class="d-flex justify-content-between gap-3 mt-4">
            <div class="icon-info w-100">
                <div class="icon">
                    <i class="pi pi-map-marker"></i>
                </div>
                <div class="description">
                    <span class="info-text">{{ instituicao()?.endereco || 'Endereço desconhecido' }}</span>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-between gap-3">
            <div class="icon-info w-100">
                <div class="icon">
                    <i class="pi pi-globe"></i>
                </div>
                <div class="description">
                    <span class="info-text">
                        <a *ngIf="instituicao()?.site; else noSite" [href]="instituicao()?.site" target="_blank" class="text-primary">{{ instituicao()?.site }}</a>
                        <ng-template #noSite>Site desconhecido</ng-template>
                    </span>
                </div>
            </div>
        </div>
    
    </div>
    